export default __webpack_public_path__ + "static/media/hotel-9.bbe08c60.jpg";